<template>
	<div>
		<v-color-picker
			show-swatches
			:swatches="swatches"
			:hide-canvas="true"
			:hide-inputs="true"
			:flat="true"
			v-model="color"
			class="ml-n1">
		</v-color-picker>
		<div class="mt-2">
			<v-text-field
				placeholder="Įveskite objekto pavadinimą"
				single-line
				dense
				hide-details
				v-model="title"
			></v-text-field>
		</div>
		<div class="mt-6">
			<div class="body-2 mb-1">Įveskite informaciją apie objektą. Galima pridėti tekstą, nuorodas, paveikslėlius ir vaizdo įrašus:</div>
			<TextEditor
				v-bind:content="description"
				ref="descriptionTextEditor"
			/>
		</div>
		<div class="mt-5">
			<v-btn
				v-on:click="updateFeatureData"
				small
			>
				Išsaugoti pakeitimus
			</v-btn>
			<v-btn
				v-on:click="doRemoveFeature"
				small
				class="ml-2"
			>
				Trinti objektą
			</v-btn>
		</div>
	</div>
</template>

<script>
	import TextEditor from "../../../../../TextEditor";
	import CommonHelper from "../../../../../helpers/CommonHelper";

	export default {
		props: {
			feature: Object,
			onEditsComplete: Function,
			removeFeature: Function
		},
		data: function(){
			var data = {
				title: this.feature.get("title"),
				description: {
					value: this.feature.get("description")
				},
				color: this.feature.get("color"),
				swatches: CommonHelper.getSwatches()
			};
			return data;
		},
		components: {
			TextEditor
		},
		methods: {
			updateFeatureData: function(){
				this.feature.set("title", this.title);
				var description = this.$refs.descriptionTextEditor.newValue;
				this.feature.set("description", description);
				this.onEditsComplete();
			},
			doRemoveFeature: function(){
				this.removeFeature(this.feature);
				this.onEditsComplete();
			}
		},
		watch: {
			color: {
				handler(val) {
					var color = val.hex || val; // Čia šioks toks hack'as... Ateity panagrinėti kodėl kartais reikšmė egzistuoja kaip objektas, o kartais kaip string'as...
					this.feature.set("color", color);
				}
			}
		}
	}
</script>